// Import necessary modules
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import "tailwindcss/tailwind.css";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const StackedBarChart = () => {
  const data = {
    labels: [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026",
      "2027",
      "2028",
      "2029",
      "2030",
      "2031",
      "2032",
    ],
    datasets: [
      {
        label: "North America",
        data: [
          5000, 6000, 7000, 8000, 8500, 9000, 10000, 15000, 25000, 35000, 45000,
        ],
        backgroundColor: "#B84167",
      },
      {
        label: "Europe",
        data: [
          4000, 4500, 5000, 5500, 6000, 6500, 7000, 10000, 20000, 30000, 40000,
        ],
        backgroundColor: "#E0C8D1",
      },
      {
        label: "Asia-Pacific",
        data: [
          3000, 3500, 4000, 4500, 5000, 6000, 7000, 11000, 21000, 31000, 41000,
        ],
        backgroundColor: "#DD517C",
      },
      {
        label: "Latin America",
        data: [
          2000, 2500, 3000, 3500, 4000, 4500, 6000, 9000, 16000, 26000, 36000,
        ],
        backgroundColor: "#923351",
      },
      {
        label: "Middle East & Africa",
        data: [
          1000, 1500, 2000, 2500, 3000, 3500, 5000, 8000, 12000, 22000, 32000,
        ],
        backgroundColor: "#431726",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          font: {
            family: "Poppins",
            size: 14,
          },
          color: "#191919",
        },
      },
      tooltip: {
        enabled: true, // Keep tooltips if you want them
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          font: {
            family: "Poppins",
            size: 14,
          },
          color: "#191919",
        },
        grid: {
          display: false,
        },
        border: {
          color: "#4a4a4a",
          width: 2,
        },
      },
      y: {
        stacked: true,
        ticks: {
          font: {
            family: "Poppins",
            size: 14,
          },

          color: "#191919",
          callback: function (value) {
            return `${value}`;
          },
        },
        border: {
          display: false,
        },
      },
    },
  };

  return (
    <div className="container mx-auto p-6 bg-white rounded-lg shadow border1 font-inter">
      <div className=" mb-4 flex flex-col lg:flex-row items-center justify-between">
        <h2 className="text-xl font-bold mb-4 font4">
          Global XYZ market Size Study & Forecast By Region 2022-2033 ($
          Million)
        </h2>
        <div className="text-center mb-2 ">
          <button className="bg-black text-white px-14 py-2 rounded-xl font-semibold hover:bg-[#21242a]">
            Download
          </button>
        </div>
      </div>

      <div className="mb-2">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};
export default StackedBarChart;
